var map = {
	"./index-on.png": "a0b8",
	"./index.png": "b828",
	"./shopping-cart-on.png": "5f84",
	"./shopping-cart.png": "cfa5",
	"./user-on.png": "4122",
	"./user.png": "6499"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2b4";